import React, { Component } from 'react';
import {withTranslation} from 'react-i18next';
import {linker} from "../../Helpers/Linker";
import InputText from "../../../../../hoc/Form/Input/Text";
import {isNull, number_format} from "../../../../../izUtils";

class Bail extends Component {

    /* selected saleMethod code (e.g. "08" = decreasing dutch auction) */
    getSaleMethodCode = () => {
        const sm = this.props.data.saleMethod;
        if (sm && sm.value && Array.isArray(sm.options)) {
            const opt = sm.options.find(o => o.value === sm.value);
            if (opt) {
                return opt.code;
            }
        }
        return null;
    }

    dutchStopWarning = () => {
        if (this.getSaleMethodCode() !== "08") {
            return null;
        }

        const data = this.props.data;
        if (!data.startingPrice || !data.stepPrice || !data.dutchStopPrice) {
            return null;
        }

        const start = parseFloat(data.startingPrice.value);
        const step = parseFloat(data.stepPrice.value);
        const stop = parseFloat(data.dutchStopPrice.value);
        if (isNaN(start) || isNaN(step) || isNaN(stop) || step <= 0) {
            return null;
        }

        /* work in cents */
        const gapCents = Math.round((start - stop) * 100);
        const stepCents = Math.round(step * 100);
        if (gapCents <= 0 || stepCents <= 0) {
            return null;
        }

        const remainder = gapCents % stepCents;
        if (remainder === 0) {
            return null;
        }

        const stopAt = (Math.round(stop * 100) + remainder) / 100;
        return (
            <div className="text-danger mt-1 mb-3">
                {this.props.t('draft.create.dutchStopWarning', {price: number_format(stopAt, 2, ',', '.')})}
            </div>
        );
    }

    formatDuration = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = value => value < 10 ? `0${value}` : value;

        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    dutchAuctionDuration = () => {
        if (this.getSaleMethodCode() !== "08") {
            return null;
        }

        const data = this.props.data;
        if (!data.startingPrice || !data.stepPrice || !data.dutchStopPrice || !data.timeStep) {
            return null;
        }

        const startCents = Math.round(parseFloat(data.startingPrice.value) * 100);
        const stopCents = Math.round(parseFloat(data.dutchStopPrice.value) * 100);
        const stepCents = Math.round(parseFloat(data.stepPrice.value) * 100);
        const timeStep = parseInt(data.timeStep.value, 10);

        if (
            !Number.isFinite(startCents) ||
            !Number.isFinite(stopCents) ||
            !Number.isFinite(stepCents) ||
            !Number.isFinite(timeStep) ||
            startCents <= stopCents ||
            stepCents <= 0 ||
            timeStep <= 0
        ) {
            return null;
        }

        const steps = Math.floor((startCents - stopCents) / stepCents) + 1;
        const duration = this.formatDuration(steps * timeStep);

        return (
            <div className="text-muted mt-1">
                {this.props.t('draft.create.dutchAuctionDuration', {duration})}
            </div>
        );
    }

    /* dutchStopPrice is rendered directly (not via linker) so the reachability
       warning can sit inside the input column, right under the field. */
    dutchStopField = () => {
        const d = this.props.data.dutchStopPrice;
        if (d === undefined) {
            return null;
        }
        return (
            <InputText key="dutchStopPrice" type="float" error={d.error} cols="4/8" name="dutchStopPrice"
                       label={d.label} display={d.display} mandatory={d.mandatory} arrayType="root"
                       value={isNull(d.value) ? '' : d.value} change={this.props.textChangeRootHandler}
                       belowInput={this.dutchStopWarning()} />
        );
    }

    /* timeStep is rendered directly so the calculated duration can be shown
       in the input column and update whenever one of its inputs changes. */
    timeStepField = () => {
        const d = this.props.data.timeStep;
        if (d === undefined) {
            return null;
        }
        return (
            <InputText key="timeStep" type="integer" error={d.error} cols="4/8" name="timeStep"
                       label={d.label} display={d.display} mandatory={d.mandatory} arrayType="root"
                       value={isNull(d.value) ? '' : d.value} change={this.props.textChangeRootHandler}
                       belowInput={this.dutchAuctionDuration()} />
        );
    }

    render() {
        const fieldsLeft = ['estimatedPrice', 'startingPrice', 'stepPrice'].map(input => {
            return linker(input, this.props.data, this.props.selectChangeRootHandler, this.props.textChangeRootHandler, null, "4/8");
        });

        return (
            <div className="tab-pane" id="bail" role="tabpanel">
                <div className="row">
                    <div className="col-lg-6">
                        {fieldsLeft}
                    </div>
                    <div className="col-lg-6">
                        {linker('securityPrice', this.props.data, this.props.selectChangeRootHandler, this.props.textChangeRootHandler, null, "4/8")}
                        {linker('lowestPrice', this.props.data, this.props.selectChangeRootHandler, this.props.textChangeRootHandler, null, "4/8")}
                        {this.dutchStopField()}
                        {this.timeStepField()}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Bail);
